/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateTagDto } from '../../models/lexplus-create-tag-dto';
import { LexplusTagMiniDto } from '../../models/lexplus-tag-mini-dto';

export interface TagsControllerCreateV1$Params {
      body: LexplusCreateTagDto
}

export function tagsControllerCreateV1(http: HttpClient, rootUrl: string, params: TagsControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusTagMiniDto>> {
  const rb = new RequestBuilder(rootUrl, tagsControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusTagMiniDto>;
    })
  );
}

tagsControllerCreateV1.PATH = '/v1/tags';
